module.exports = __webpack_public_path__ + "static/img/enterprise_img_2_en.52c5e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/enterprise_img_2_en.png
// module id = XMf+
// module chunks = 0